import './components/questionsAndAnswers';
import './components/more';
import './components/js-form-validator';
import Stepper from './components/stepper';
import Litepicker from 'litepicker';
import validatorOptions from './components/validatorOptions';

(function () {
  const steps = document.querySelectorAll('.stepper__step');
  const stepsWrapper = document.querySelector('.stepper');
  const nextStepButton = document.querySelector('.stepper__next');
  const prevStepButton = document.querySelector('.stepper__previous');
  const submitButton = document.querySelector('.stepper__submit');
  const progressBar = document.querySelector('.stepper__progressBar');
  const adoptionGroupInput = document.getElementById('weddingFormDestinationAdoptionGroup');
  const adoptionCountryWrapper = document.getElementById('weddingFormAdoptionCountryWrapper');
  const adoptionCountrySelect = document.getElementById('weddingFormAdoptionCountry');

  const toggleAdoptionCountry = () => {
    if (!adoptionGroupInput || !adoptionCountryWrapper || !adoptionCountrySelect) {
      return;
    }

    const isVisible = adoptionGroupInput.checked;
    adoptionCountryWrapper.hidden = !isVisible;
    adoptionCountrySelect.disabled = !isVisible;
  };

  const validator = [];
  for (let i = 0; i < steps.length; i++) {
    const fieldset = document.getElementById('formStep' + (i + 1));
    if (fieldset) {
      validator[i] = new Validator(
        fieldset,
        function (err, res) {
          return res;
        },
        validatorOptions
      );
      let k = i;
      for (const element of fieldset.elements) {
        element.addEventListener('change', function () {
          toggleAdoptionCountry();
          setTimeout(function () {
            if (validator[k].validate()) {
              nextStepButton.disabled = false;
              submitButton.disabled = false;
            } else {
              nextStepButton.disabled = true;
              submitButton.disabled = true;
              validator[k].showErrors();
            }
          }, 50);
        });

        element.addEventListener('keydown', function () {
          setTimeout(function () {
            if (validator[k].validate()) {
              nextStepButton.disabled = false;
              submitButton.disabled = false;
            }
          }, 50);
        });
      }
    }
  }

  const stepper = new Stepper(
    steps,
    stepsWrapper,
    nextStepButton,
    prevStepButton,
    submitButton,
    progressBar,
    validator
  );

  toggleAdoptionCountry();

  const dateInput = document.getElementById('weddingFormDate');
  const datepicker = new Litepicker({
    element: dateInput,
    lang: 'pl',
    minDate: new Date(),
    autoRefresh: true,
    onSelect: function () {
      if ('createEvent' in document) {
        const evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        dateInput.dispatchEvent(evt);
      } else dateInput.fireEvent('onchange');
    },
  });
})();
